<ngx-charts-advanced-pie-chart
  *ngIf="isReady"
  [view]="view"
  [scheme]="ColorSchem"
  [results]="Single"
  [gradient]="false"
  
  >
</ngx-charts-advanced-pie-chart>